import { useMemo } from "react";

export const useSearchParams = <
  T extends string,
>(): {[K in T]?: string} => {
  const search = window.location.search;

  return useMemo(() => {
    const params = new URLSearchParams(search);
    return Object.fromEntries(params.entries()) as Record<T, string | undefined>;
  }, [search]);
};
